import React from 'react';
import { PavForm } from './features/pav-form/PavForm';
import './App.css';
import Navbar from "react-bootstrap/Navbar";


function App() {
  return (
    <div className="App">
      <Navbar bg="dark" variant="dark">
        <Navbar.Brand href="https://developer.geoscape.com.au/">
          <img
            alt="Geoscape"
            src="Geoscape_Logo_White_RGB.png"
            height={"48"}
            className="d-inline-block align-top"
            />
        </Navbar.Brand>
      </Navbar>
      <PavForm />
    </div>
  );
}

export default App;
